import React, {useEffect, useState} from "react"
import {Map, Marker, ZoomControl} from "pigeon-maps"

let center = [0, 0];

export function MyMap({markers}) {
    const [zoom, setZoom] = useState(0)
    const [mapCenter, setMapCenter] = useState();
    const [first, setFirst] = useState([]);
    const [second, setSecond] = useState([]);
    const [mapKey, setMapKey] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        console.log(markers)
        if (markers.length == 1) {
            if (markers[0].length > 0) {
                setFirst([Number(markers[0].split(" ")[0]), Number(markers[0].split(" ")[1])])
            }
            setZoom(15);
        } else if (markers.length == 2) {
            const desiredWidthOrHeight = 520;
            let lat1 = Number(markers[0].split(" ")[0])
            let lat2 = Number(markers[1].split(" ")[0])
            let lon1 = Number(markers[0].split(" ")[1])
            let lon2 = Number(markers[1].split(" ")[1])
            let distancePixels = 156543.03392 * Math.cos(((lat1 + lat2) / 2) * (Math.PI / 180)) * Math.abs(lon1 - lon2);

            while (distancePixels > desiredWidthOrHeight) {
                setZoom(zoom + 2);
                distancePixels /= 2;
            }
            if (markers[0].length > 0) {
                setFirst([lat1, lon1])
            }
            if (markers[1].length > 0) {
                setSecond([lat2, lon2])
            }
        }

        let sumLat = 0;
        let sumLon = 0;

        for (const marker of markers) {
            const [lat, lon] = marker.split(" ").map(Number);
            sumLat += lat;
            sumLon += lon;
        }
        const center = [sumLat / markers.length, sumLon / markers.length];
        setMapCenter(center);

        setMapKey(mapKey + 1);

        // Simulate loading completion
        setTimeout(() => setIsLoading(false), 800);
    }, [markers])

    useEffect(() => {
        console.log("debug---", first, second, mapCenter, zoom)
    }, [first, second, zoom])

    function mapTiler(x, y, z, dpr) {
        return `https://tile.openstreetmap.org/${z}/${x}/${y}.png`
    }

    return (
        <div className="relative">
            {/* Animated background glow */}
            <div className="absolute inset-0 bg-gradient-to-r from-red-600/20 via-black/10 to-red-600/20 blur-3xl animate-pulse"></div>

            <div className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 p-8 rounded-3xl shadow-2xl border border-red-500/30">
                {/* Glowing border effect */}
                <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-red-500/20 via-white/10 to-red-500/20 blur-sm"></div>

                <div className="relative z-10">
                    {/* Sexy header with coordinates and copy buttons */}
                    <div className="mb-8 space-y-4">
                        <div className="text-center">
                            <div className="inline-flex items-center gap-4 bg-black/40 backdrop-blur-sm px-6 py-3 rounded-full border border-red-500/30">
                                <div className="flex items-center gap-2">
                                    <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse shadow-lg shadow-white/50"></div>
                                    <span className="text-white font-medium tracking-wide">BEFORE</span>
                                </div>
                                <div className="w-px h-6 bg-gradient-to-b from-red-500 to-white opacity-50"></div>
                                <div className="flex items-center gap-2">
                                    <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse shadow-lg shadow-red-500/50"></div>
                                    <span className="text-red-400 font-medium tracking-wide">AFTER</span>
                                </div>
                            </div>
                        </div>

                        {/* Coordinates display with copy buttons */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {first.length > 0 && (
                                <div className="bg-black/60 backdrop-blur-sm p-4 rounded-xl border border-white/20">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <div className="text-xs text-white/70 font-medium mb-1">BEFORE COORDINATES</div>
                                            <div className="text-white font-mono text-sm">
                                                {first[0].toFixed(6)}, {first[1].toFixed(6)}
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => navigator.clipboard.writeText(`${first[0].toFixed(6)}, ${first[1].toFixed(6)}`)}
                                            className="bg-white/10 hover:bg-white/20 p-2 rounded-lg transition-all duration-200 hover:scale-105 border border-white/20"
                                            title="Copy coordinates"
                                        >
                                            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            )}

                            {second.length > 0 && (
                                <div className="bg-black/60 backdrop-blur-sm p-4 rounded-xl border border-red-500/30">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <div className="text-xs text-red-400 font-medium mb-1">AFTER COORDINATES</div>
                                            <div className="text-white font-mono text-sm">
                                                {second[0].toFixed(6)}, {second[1].toFixed(6)}
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => navigator.clipboard.writeText(`${second[0].toFixed(6)}, ${second[1].toFixed(6)}`)}
                                            className="bg-red-500/20 hover:bg-red-500/30 p-2 rounded-lg transition-all duration-200 hover:scale-105 border border-red-500/30"
                                            title="Copy coordinates"
                                        >
                                            <svg className="w-4 h-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Loading overlay */}
                    {isLoading && (
                        <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/80 backdrop-blur-sm rounded-2xl">
                            <div className="flex flex-col items-center gap-4">
                                <div className="relative">
                                    <div className="w-16 h-16 border-4 border-red-500/30 rounded-full animate-spin"></div>
                                    <div className="absolute inset-2 w-12 h-12 border-4 border-white/30 rounded-full animate-spin animation-delay-150"></div>
                                </div>
                                <div className="text-white font-medium tracking-widest">LOADING MAP</div>
                            </div>
                        </div>
                    )}

                    {/* Map container with enhanced styling */}
                    <div className="relative group">
                        {/* Animated corner accents */}
                        <div className="absolute -top-2 -left-2 w-8 h-8 border-l-2 border-t-2 border-red-500 rounded-tl-lg opacity-60 group-hover:opacity-100 transition-all duration-300"></div>
                        <div className="absolute -top-2 -right-2 w-8 h-8 border-r-2 border-t-2 border-red-500 rounded-tr-lg opacity-60 group-hover:opacity-100 transition-all duration-300"></div>
                        <div className="absolute -bottom-2 -left-2 w-8 h-8 border-l-2 border-b-2 border-red-500 rounded-bl-lg opacity-60 group-hover:opacity-100 transition-all duration-300"></div>
                        <div className="absolute -bottom-2 -right-2 w-8 h-8 border-r-2 border-b-2 border-red-500 rounded-br-lg opacity-60 group-hover:opacity-100 transition-all duration-300"></div>

                        {/* Enhanced map container */}
                        <div className="relative overflow-hidden rounded-2xl shadow-2xl border border-white/20 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-red-500/20">
                            {/* Subtle inner glow */}
                            <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 via-transparent to-white/5 pointer-events-none"></div>

                            <div className="relative bg-black/20 backdrop-blur-sm">
                                <Map
                                    provider={mapTiler}
                                    key={mapKey}
                                    height={400}
                                    defaultCenter={mapCenter}
                                    defaultZoom={zoom || 16}
                                    className="filter contrast-110 brightness-95"
                                >
                                    {first.length > 0 && (
                                        <Marker
                                            width={50}
                                            anchor={first}
                                            color={"#44ef5b"}
                                        />
                                    )}
                                    {second.length > 0 && (
                                        <Marker
                                            width={50}
                                            anchor={second}
                                            color={"#ef4444"}
                                        />
                                    )}
                                </Map>
                            </div>
                        </div>

                        {/* Custom zoom controls */}
                        <div className="absolute top-4 right-4 flex flex-col gap-2">
                            <button
                                onClick={() => setZoom(Math.min(zoom + 1, 18))}
                                className="bg-black/70 backdrop-blur-md hover:bg-black/80 p-3 rounded-xl border border-white/30 transition-all duration-200 hover:scale-105 group"
                                title="Zoom in"
                            >
                                <svg className="w-5 h-5 text-white group-hover:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                </svg>
                            </button>
                            <button
                                onClick={() => setZoom(Math.max(zoom - 1, 1))}
                                className="bg-black/70 backdrop-blur-md hover:bg-black/80 p-3 rounded-xl border border-white/30 transition-all duration-200 hover:scale-105 group"
                                title="Zoom out"
                            >
                                <svg className="w-5 h-5 text-white group-hover:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 12H6" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Bottom accent bar */}
                    <div className="mt-6 h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full opacity-60"></div>
                </div>
            </div>
        </div>
    )
}

export default MyMap;
